export default __webpack_public_path__ + "static/media/viber.9486abc6.svg";